import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import {
  ADD_LANGUAGE,
  ANNOUNCEMENT_SELECT,
  LOCALE_DELETE_ASYNC,
  LOCALE_REQUEST_ASYNC,
} from '../constants'

import {
  ANNOUNCEMENT_UPDATE,
  CHANGE_RECIPIENTS_SEARCH_FILTER,
  DATA_UPDATE_ASYNC,
  RECIPIENTS_COUNT_REQUEST_ASYNC,
  RECIPIENTS_REQUEST_ASYNC,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
    recipientsSearchFilter: '',
    recipientsSelectorData: {},
    recipientsSelectorDataLoader: false,
    recipients: {
      loader: false,
      error: null,
      total: 0,
      data: [],
    },
    hasChangedRecipientsField: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case LOCALE_DELETE_ASYNC.SUCCESS:
      case FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS:
        return {
          ...state,
          hasChangedRecipientsField: false,
        }
      case ANNOUNCEMENT_UPDATE:
        return {
          ...state,
          data: { ...state.data, update: action.payload.text },
        }
      case LOCALE_REQUEST_ASYNC.INITIATE:
      case DATA_UPDATE_ASYNC.INITIATE:
      case ANNOUNCEMENT_SELECT:
        return {
          ...state,
          loader: true,
          hasChangedRecipientsField: false,
        }
      case LOCALE_REQUEST_ASYNC.SUCCESS:
      case LOCALE_REQUEST_ASYNC.CANCEL:
      case DATA_UPDATE_ASYNC.SUCCESS:
        return { ...state, loader: false }
      case DATA_UPDATE_ASYNC.ERROR:
      case LOCALE_REQUEST_ASYNC.ERROR:
        return { ...state, loader: false, error: action.error }
      case RECIPIENTS_REQUEST_ASYNC.INITIATE:
        return { ...state, recipientsSelectorDataLoader: true }
      case RECIPIENTS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          recipientsSelectorData: action.payload.data,
          recipientsSelectorDataLoader: false,
        }
      case RECIPIENTS_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case RECIPIENTS_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case RECIPIENTS_COUNT_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          recipients: {
            ...state.recipients,
            loader: true,
            error: null,
          },
          hasChangedRecipientsField: true,
        }
      case RECIPIENTS_COUNT_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          recipients: {
            loader: false,
            error: null,
            total: action.payload.participants.total,
            data: action.payload.data,
          },
        }
      case RECIPIENTS_COUNT_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          recipients: { ...state.recipients, loader: false },
        }
      case RECIPIENTS_COUNT_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          recipients: {
            ...state.recipients,
            loader: false,
            error: action.error,
            total: 0,
          },
        }
      case CHANGE_RECIPIENTS_SEARCH_FILTER:
        return {
          ...state,
          recipientsSearchFilter: action.payload.searchFilter,
          recipientsSelectorDataLoader: true,
          hasChangedRecipientsField: true,
        }
      case ADD_LANGUAGE:
        return {
          ...state,
          hasChangedRecipientsField: false,
        }
      default:
        return state
    }
  }
}
